import { useEffect, useState } from "react";
import { Link } from "react-scroll";
import DynamicToolTip from "./DynamicToolTip";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 118) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <Link
      to="toTop"
      smooth={true}
      duration={500}
      id="toTop"
      className={`scroll-to-top ${isVisible ? "show" : ""}`}
      style={{ cursor: "pointer" }}
    >
      <DynamicToolTip title="Scroll to Top">
        <i className="fa fa-angle-up"></i>
      </DynamicToolTip>
    </Link>
  );
};

export default ScrollToTop;
